import {
  APPLICATION_STATUS_BASE_DATA,
  APPLICATION_STATUS_DESCRIPTION,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_DONE,
  APPLICATION_STATUS_SUMMARY,
} from "@/src/services/employmentContract/applicationStatus";
import { FormSteps } from "@/src/types/FormServiceBase";
import HintBox from "@/src/components/Box/HintBox/HintBox";
import ProgressBar from "@/src/components/ProgressBar/ProgressBar";
import progressBarsteps from "./progressBarSteps";
import employmentContractFormSteps from "@/src/services/employmentContract/formSteps";
import React from "react";
import EmploymentContractBase from "@/src/components/Form/EmploymentContract/EmploymentContractBase";
import EmploymentContractDescription from "@/src/components/Form/EmploymentContract/EmploymentContractDescription";
import { DocumentsForm } from "@/src/components/Form/DocumentsForm/DocumentsForm";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_BASE_DATA]: {
    ...employmentContractFormSteps[APPLICATION_STATUS_BASE_DATA],
    render: (props) => (
      <>
        <HintBox headline={"Wir kümmern uns um Ihre Vertragsangelegenheit!"}>
          Schildern Sie uns bitte kurz Ihr arbeitsrechtliches Anliegen anhand der folgenden Fragen. Halten Sie relevante Dokumente wie Ihren Arbeitsvertrag,
          Abmahnungen oder Gehaltsabrechnungen bereit, falls möglich. Jede Information hilft uns dabei, Sie bestmöglich zu beraten und direkt die passenden
          rechtlichen Schritte einzuleiten. Sollten Sie bei einer Frage unsicher sein, machen Sie sich keine Sorgen: Sie haben zusätzlich die Möglichkeit,
          Ihren Fall frei aus Ihrer Sicht zu schildern.
        </HintBox>
        <ProgressBar steps={progressBarsteps} active={"concern"} progress={25} />
        <EmploymentContractBase {...props} hideCaseCategories={true} />
      </>
    ),
  },
  [APPLICATION_STATUS_DESCRIPTION]: {
    ...employmentContractFormSteps[APPLICATION_STATUS_DESCRIPTION],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={25} />
        <EmploymentContractDescription {...props} applicationStatus={employmentContractFormSteps[APPLICATION_STATUS_DESCRIPTION].applicationStatus} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    ...employmentContractFormSteps[APPLICATION_STATUS_DOCUMENTS],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={75} />
        <DocumentsForm submitProps={props.submitProps} product={props.product} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: employmentContractFormSteps[APPLICATION_STATUS_SUMMARY],
  [APPLICATION_STATUS_DONE]: employmentContractFormSteps[APPLICATION_STATUS_DONE],
};

export default formSteps;
